export default __webpack_public_path__ + "img/7f9c78e944404e85442a70d37e325840.png";